import * as React from "react";
import { styled } from "@mui/material/styles";
import MuiMenuItem from "@mui/material/MenuItem";
import ListItemIcon, { listItemIconClasses } from "@mui/material/ListItemIcon";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import { useNavigate } from "react-router-dom";
import KEYCLOAK_CONFIG from "../config/keycloakConfig";

const MenuItem = styled(MuiMenuItem)({
  margin: "2px 0",
});

export default function OptionsMenu() {
  const navigate = useNavigate();

  const handleLogout = () => {
    const idToken = localStorage.getItem("idToken");
    localStorage.clear();

    // Keycloak session'ı da sonlandır
    if (idToken) {
      const logoutUrl =
        `${KEYCLOAK_CONFIG.realmUrl}/protocol/openid-connect/logout` +
        `?id_token_hint=${encodeURIComponent(idToken)}` +
        `&post_logout_redirect_uri=${encodeURIComponent(KEYCLOAK_CONFIG.redirectUri)}`;
      window.location.href = logoutUrl;
    } else {
      navigate("/login");
    }
  };

  return (
    <React.Fragment>
      <MenuItem
        onClick={handleLogout}
        sx={{
          [`& .${listItemIconClasses.root}`]: {
            ml: "auto",
            minWidth: 0,
          },
          borderColor: "transparent",
        }}
      >
        <ListItemIcon>
          <LogoutRoundedIcon fontSize="small" />
        </ListItemIcon>
      </MenuItem>
    </React.Fragment>
  );
}
